import styled from 'styled-components';

import { colors } from '@/globalStyles';

export const CTAPanelStyled = styled.div`
  display: grid;
  grid-template-columns: ${props => props.$isInsertButtonVisible ? '1fr 1fr' : '1fr'};
  gap: 20px;
  padding: 20px;
  background-color: ${colors.primary};
  height: 100px;
`;
